import { createApp } from 'vue';
import { createPinia } from 'pinia';
import config from '@/config';
import DHCommonPlugins from '@/plugins';
import GTag from '@/plugins/gtag';
import App from '@/App.vue';
import router from '@/router';

const app = createApp(App);
// Create and configure Pinia
const pinia = createPinia();
app.use(pinia);

// Install plugins
app.use(DHCommonPlugins, router);

if (config.analyticsEnabled) {
  app.use(GTag, {
    config: config.gtm,
  });
}

// Install router
app.use(router);

// Mount the app
app.mount('#app');
